export const mapDataCompleted = (data, ElapsedTimeSince) => {
  return data.map((item) => ({
    ...item,
    title: item.title,
    id: item.id,
    favoritesId: item?.favorites?.[0]?.id,
    classUrl: item?.planEntryUrl,
    seriesUrl: item?.planUrl,
    seriesName: item?.plan?.title,
    isFavoritesAvailable: item?.favorites?.length,
    image: item?.videoThumbnail
      ? item.videoThumbnail
      : item?.plan?.thumbnailImage,
    style: item?.style,
    duration: item?.humanDuration,
    dateCompleted: ElapsedTimeSince(item?.dateCompleted),
    plan: {
      coaches:
        item?.plan?.coaches?.map((coach) => ({
          firstName: coach.firstName,
          lastName: coach.lastName
        })) || [],
      primaryCategory: { title: item?.category?.title },
      subcategory: { title: item?.subcategory?.title },
      difficultyLevel: item?.classDifficulty,
      title: item?.plan?.title,
      slug: item?.plan?.slug,
      singleClass: item?.plan?.singleClass
    },
    completedAt: item?.completedAt
  }))
}
